// Components
import { ShipmentOptionsTableRow } from "./ShipmentOptionsTableRow";

// Material-ui imports
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export function ShipmentOptionsTable({ lines, staff, shipmentDate }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="Shipment Options">
        <TableHead>
          <TableRow>
            <TableCell>Name (ID)</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Colour</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Fit</TableCell>
            <TableCell>Stock</TableCell>
            <TableCell>Price</TableCell>
            <TableCell>Qty</TableCell>
            <TableCell>Total</TableCell>
            <TableCell>SLA</TableCell>
            <TableCell>Return</TableCell>
            <TableCell>Shipment</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {lines?.map((line) => (
            <ShipmentOptionsTableRow
              line={line}
              key={line.staffLineNo + line.lineNo}
              staff={staff}
              shipmentDate={shipmentDate}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
